<template>
  <nav :class="{ closed: !isOpen }">
    <div @click="toggleOpen">
      {{ $currentCollection.genie }}<DropdownIcon class="icon" />
    </div>
    <ul class="drop-panel">
      <li
        v-for="collection in otherCollections"
        :key="collection.id"
        :class="{disabled: !collection.available}"
      >
        <component
          :is="collection.available ? 'router-link' : 'div'"
          :to="collection.available ? `/${collection.id}/${product.shortId}` : null"
        >
          {{ collection.available ? collection.genie : `${$content.available_in.format({ year: collection.year })}` }}
        </component>
      </li>
    </ul>
  </nav>
</template>
<script>
import DropdownIcon from '@/assets/images/common/icons/dropdown.svg?inline';

export default {
  name: 'AvailableCollectionsDropdown',
  components: {
    DropdownIcon,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    otherAvailableCollections() {
      const collection = this.$collections;
      return collection.filter(col => col.id !== this.$currentCollection.id && col.available);
    },
    otherCollections() {
      const collection = this.$collections;
      return collection.filter(col => col.id !== this.$currentCollection.id);
    },
  },
  methods: {
    toggleOpen() {
      // if (this.otherAvailableCollections.length === 0) return;
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
<style lang="stylus" scoped>
nav {
  display: flex;
  flex-direction: column;
  width: fit-content;
  position: relative;

  &.closed {
    .icon {
      transform: rotate(0deg);
    }
    ul.drop-panel {
      max-height: 0;
    }
  }

  div {
    display: flex;
    align-items: center;
    font-size: 16px;
    padding: 15px 0;
    gap: 15px;
    border-bottom: 1px solid var(--text-color);
    width: 100%;
    cursor: pointer;
    justify-content: space-between;

    +mobile() {
      color: var(--inverted-text-color);
      border-bottom: 1px solid var(--inverted-text-color);
    }

    .icon {
      transition: transform 0.3s ease;
      transform: rotate(-180deg)
      * {
        stroke: currentColor;
      }
    }
  }
  ul.drop-panel {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 16px;
    border-radius: 0 0 10px 10px;
    background-color: var(--white-color);
    width: 100%;
    position: absolute;
    bottom: 0;
    transform: translateY(100%);
    transition: all 0.3s ease;
    transition-behavior: allow-discrete;
    max-height: 300px;
    overflow: hidden;

    +mobile() {
      background-color: var(--main-color);
    }

    li {
      display: flex;
      border-bottom: 1px solid var(--light-color);
      width: 100%;
      gap: 0;
      transition: background-color 0.3s ease;
      color: var(--inverted-text-color);
      font-size: 14px;
      text-align: left;

      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }

      +mobile() {
        color: var(--text-color);
      }

      &:last-child {
        border-bottom: none;
      }

      a, div {
        padding: 12px 15px;
        color: var(--inverted-text-color);
        +mobile() {
          color: var(--text-color);
        }
      }

      &:hover {
        background-color: var(--light-color);
      }
    }
  }
}
</style>
